/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Rolefrompersonendedtrough4Inputs */

const de__field_rolefrompersonendedtrough4 = /** @type {(inputs: _Field_Rolefrompersonendedtrough4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendet durch Person in Rolle`)
};

/**

* @param {_Field_Rolefrompersonendedtrough4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_rolefrompersonendedtrough4 = /** @type {((inputs?: _Field_Rolefrompersonendedtrough4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Rolefrompersonendedtrough4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_rolefrompersonendedtrough4(inputs)
});
export { _field_rolefrompersonendedtrough4 as "_field_roleFromPersonEndedTrough" }